/** Ignore the pointer that opened a menu so Android WebView does not close it on the same tap. */
export const TOUCH_OPEN_IGNORE_MS = 400;

/** Ignore small finger movement when deciding tap vs scroll in a portaled list. */
export const LIST_PICK_MOVE_SLOP_PX = 10;

/**
 * After a list-row pointer starts, ignore the field's blur commit briefly.
 * Tablet blur runs on pointer down (setTimeout 0) before pointer up selects the row.
 */
export const TOUCH_LIST_BLUR_YIELD_MS = 50;

export function touchPickShouldYieldBlur(input: {
  pickPending: boolean;
  nowMs: number;
  yieldUntilMs: number;
}): boolean {
  return input.pickPending || input.nowMs < input.yieldUntilMs;
}

/**
 * Decide whether a document pointerdown should be ignored (not dismiss the open menu).
 *
 * Touch and pen pointers get a fresh `pointerId` per contact, so matching the opening id only
 * ignores the tap that opened the menu. A mouse keeps one constant `pointerId` for its lifetime,
 * so id matching must be skipped for `eventPointerType === "mouse"`; otherwise a click outside
 * would never close the menu.
 */
export function shouldIgnoreOpeningPointer(input: {
  openedAtMs: number;
  openingPointerId: number | null;
  nowMs: number;
  eventPointerId: number;
  eventPointerType?: string | null;
}): boolean {
  const isMouse = input.eventPointerType === "mouse";
  if (
    !isMouse &&
    input.openingPointerId != null &&
    input.eventPointerId === input.openingPointerId
  ) {
    return true;
  }
  return input.nowMs - input.openedAtMs < TOUCH_OPEN_IGNORE_MS;
}

export function pointerMovedBeyondTapSlop(
  startX: number,
  startY: number,
  clientX: number,
  clientY: number,
  slopPx: number = LIST_PICK_MOVE_SLOP_PX,
): boolean {
  const deltaX = clientX - startX;
  const deltaY = clientY - startY;
  return deltaX * deltaX + deltaY * deltaY > slopPx * slopPx;
}
